import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { checkMultiFilter, Filter, FilterItem, FilterType } from '../models/filter';
import { FiltersPanelService } from '../filters-panel.service';
import { Utils } from '../../../services/utils.service';
import { SHARED_MODULES } from '../../../../shared.';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';
import { PhIconWrapperComponent } from '../../ph-icon-wrapper/ph-icon-wrapper.component';
import { SearchComponent } from '../../search/search.component';
import { TreeCheckboxComponent } from '../tree-checkbox/tree-checkbox.component';

@Component({
    selector: 'app-tree-multi-filter',
    templateUrl: './tree-multi-filter.component.html',
    styleUrls: ['./tree-multi-filter.component.scss'],
	imports: [SHARED_MODULES, PhIconComponent, PhIconWrapperComponent, SearchComponent, TreeCheckboxComponent],
    standalone: true
})
export class TreeMultiFilterComponent implements OnInit {

	@Input('filter') filter: Filter;
	@Input('content') content: HTMLElement;
	@Input('invalidLabel') invalidLabel: string;

	@Output('check') check: EventEmitter<void> = new EventEmitter<void>();
	@Output('search') search: EventEmitter<void> = new EventEmitter<void>();

	filterType = FilterType;

	constructor(private panelService: FiltersPanelService) {}

	ngOnInit() {
		this.panelService.getApplyPanel().subscribe((apply: boolean) => {
			if (!apply) this.clearSelected();
		});
	}

	isFixed(panel, content: HTMLElement): boolean {
		if (!panel.expanded) return false;
		const offset = panel._viewContainerRef.element.nativeElement.offsetTop - 70,
			height = panel._viewContainerRef.element.nativeElement.clientHeight;
		if (offset == content.scrollTop) return false;
		return offset < content.scrollTop && offset + height > content.scrollTop;
	}

	checkElement(): void {
		this.setSelected(this.filter.data);
		this.check.emit();
	}

	setSelected(list: Array<FilterItem>, parentCheck: boolean = false): void {
		const selectedIds: Array<number> = this.filter.selectingStrategy.getSelected();

		list.forEach((element: FilterItem) => {
			if (
				(this.filter.checkingStrategy.getKey(element.id as number).checked) &&
				(!this.filter.searchQuery && !parentCheck || !!this.filter.searchQuery && !element.children.length)
			) {
				if (!selectedIds.includes(element.id as number)) this.filter.selectingStrategy.setCustomSelected(element);
			} else {
				if (
					selectedIds.includes(element.id as number) &&
					(
						!this.filter.checkingStrategy.getKey(element.id as number).indeterminate ||
						!Utils.to1DArray(this.filter.selectingStrategy.getInitial()).includes(element.id) ||
						(element.children?.length && element.children.some((child: FilterItem) => !this.filter.checkingStrategy.any(child.id as number)))
					)
				) this.filter.selectingStrategy.removeSelected(element.id as number);
			}
			if (element.children.length)
				this.setSelected(element.children, this.filter.checkingStrategy.getKey(element.id as number).checked);
		});
	}

	removeSelected(id: number): void {
		this.filter.selectingStrategy.removeSelected(id);
		checkMultiFilter(this.filter, this.filter.data, this.filter.selectingStrategy.getInitial());
		this.check.emit();
	}

	clearSelected(): void {
		this.filter.checkingStrategy.clear();
		this.filter.selectingStrategy.clear();
		checkMultiFilter(this.filter, this.filter.data);
		this.check.emit();
	}

	setSearched(query: string): void {
		if (this.filter.searchQuery == query.trim()) return;
		this.filter.searchQuery = query.trim();
		this.filter.search(this.filter).subscribe((tree: Array<FilterItem>) => {
			this.filter.data = tree;
			checkMultiFilter(
				this.filter,
				this.filter.data,
				this.filter.selectingStrategy.getInitial(),
				false,
				[],
				false,
				!!this.filter.searchQuery.length
			);
		});
	}
}
